import { render, staticRenderFns } from "./AddMedicine.vue?vue&type=template&id=5a8b9b79"
import script from "./AddMedicine.vue?vue&type=script&lang=js"
export * from "./AddMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports